export default {
    name: 'A3',
    margin: '24px 0'
  }